import { Select as AntSelect } from 'antd'
import { LabeledValue, RefSelectProps, SelectProps as AntSelectProps } from 'antd/lib/select'
import classNames from 'classnames'
import _ from 'lodash'
import React, { useRef } from 'react'
import { SpaceProps } from 'styled-system'

import { useWindowScroll } from '../../hooks/useWindowScroll'
import { CenterChildren } from '../Center'
import { Spin, SpinSize } from '../Spin'
import { ThemeWrapper } from '../theme'

import { StyledSelect } from './helper'

export type SelectOption = { value: string; label: string | React.ReactNode }

export const Option = AntSelect.Option
export const OptionGroup = AntSelect.OptGroup

export type SelectVariants = 'primary' | 'secondary' | 'default' | 'gray'

export type AntLabeledValue = LabeledValue

export interface SelectProps
  extends React.PropsWithChildren<
    AntSelectProps<React.ReactText | React.ReactText[] | LabeledValue | LabeledValue[] | undefined> & SpaceProps
  > {
  $colorVariant?: SelectVariants
  options?: SelectOption[]
  $orientation?: 'vertical' | 'horizontal'
  showOptionsOnLoading?: boolean
  inputCustomization?: boolean
}

const defaultProps: SelectProps = {
  $colorVariant: 'default'
}

export const Select = ({
  children,
  options,
  value,
  showOptionsOnLoading = false,
  inputCustomization = true,
  ...rest
}: SelectProps) => {
  const selectRef = useRef<RefSelectProps>(null)

  useWindowScroll(false, () => {
    selectRef.current?.blur()
  })

  return (
    <ThemeWrapper>
      <StyledSelect
        className={classNames({ ['ant-select-customize-input']: inputCustomization })}
        {...defaultProps}
        {..._.omit(rest, 'error')}
        value={_.isEmpty(value) ? undefined : value}
        ref={selectRef}
        dropdownRender={
          rest.loading && (!showOptionsOnLoading || !options || options.length === 0)
            ? () => (
                <CenterChildren my={2}>
                  <Spin size={SpinSize.Large} />
                </CenterChildren>
              )
            : undefined
        }
      >
        {!options && children}
        {options &&
          _.map(options, (opt, i) => (
            <Option key={i} value={opt.value}>
              {opt.label}
            </Option>
          ))}
      </StyledSelect>
    </ThemeWrapper>
  )
}
